import React from 'react';
import classNames from 'classnames';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import Badge from 'components/v2/Badge';
import Table from 'components/v2/Table';
import { useTranslation } from 'react-i18next';
import { unescapeSpecialChars } from 'helpers/helper_functions';

const WarehouseSummary = ({ data = {}, defaultOpen }) => {
  const { t } = useTranslation();

  const renderViewMore = (open) => {
    return (
      <div className="flex-shrink-0 flex-grow-0">
        <div className={classNames('flex-grow-0 flex-shrink-0 cursor-pointer')}>
          {!open && <ChevronRightIcon className="w-5 h-5" />}
          {open && <ChevronDownIcon className="w-5 h-5" />}
        </div>
      </div>
    );
  };
  const renderHeading = (open) => {
    return (
      <div className="flex items-center space-x-2 relative">
        {renderViewMore(open)}
        <h3 className="flex-1 font-bold">{data?.address}</h3>
      </div>
    );
  };

  const renderTitle = (name) => {
    return (open) => {
      return (
        <div className="flex items-center space-x-2 relative">
          {renderViewMore(open)}
          <h3 className="flex-1 font-semibold text-gray-600">
            {unescapeSpecialChars(name)}
          </h3>
        </div>
      );
    };
  };

  const renderAssociations = () => {
    return data?.shippers?.map(({ warehouseUsers, ...shipper }) => (
      <CollapsibleItem
        className="px-6 mt-4"
        renderTitle={renderTitle(
          shipper.company_name || `${shipper.first_name} ${shipper.last_name}`,
        )}
        key={shipper._id}
        position="left"
        hideIcon
      >
        <div
          data-testid="warehouse-summary-item"
          className="table-wrapper mt-4"
        >
          <Table
            headers={[
              { field: 'name', label: t('WAREHOUSE_USER') },
              { field: 'status', label: t('STATUS') },
            ]}
            columns={[
              {
                field: 'name',
                render: (value, cell) =>
                  value || `${cell.first_name} ${cell.last_name}`,
              },
              {
                field: 'status',
                render: (status) => (
                  <Badge className="-ml-1" color={status ? 'green' : 'gray'}>
                    {status ? t('ACTIVE') : t('INACTIVE')}
                  </Badge>
                ),
              },
            ]}
            data={warehouseUsers}
            colWidths={[60, 40]}
          />
        </div>
      </CollapsibleItem>
    ));
  };

  return (
    <CollapsibleItem
      renderTitle={renderHeading}
      className="flex-1"
      hideIcon
      defaultOpen={defaultOpen}
    >
      {data?.shippers?.length ? (
        renderAssociations()
      ) : (
        <p className="ml-8 mt-2">{t('NO_SHIPPER_ASSOCIATION')}</p>
      )}
    </CollapsibleItem>
  );
};

export default WarehouseSummary;
